import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Drawer } from './drawer';
import { Share2 } from 'lucide-react';
import { Button } from '@repo/ui/components/button';

interface ShareProps {
  data: ShareData;
  children: React.ReactNode;
  title?: string;
  className?: string;
}

const isShareSupported = (data: ShareData) => {
  const supported = navigator && 'share' in navigator && 'canShare' in navigator;
  const canShare = supported && navigator.canShare(data);
  return supported && canShare;
};

const isClipboardSupported = () => {
  const supported = navigator && 'clipboard' in navigator && 'writeText' in navigator.clipboard;
  return supported;
};

export const Share = ({ data, children, title, className }: ShareProps) => {
  const [drawerMode, setDrawerMode] = useState<boolean | null>(null);
  const [showDrawer, setShowDrawer] = useState(false);

  useEffect(() => {
    if (!isShareSupported(data) && !isClipboardSupported()) {
      setDrawerMode(true);
    }
  }, []);

  const handleShare = () => {
    if (drawerMode) {
      setShowDrawer(true);
    } else if (isClipboardSupported()) {
      navigator.clipboard.writeText(data.url ? data.url : data.text ?? '');
      toast.success(data.url ? 'URL copiada al portapapeles' : 'Texto copiado al portapapeles');
    } else if (isShareSupported(data)) {
      navigator.share(data);
    } else {
      setDrawerMode(true);
    }
  };

  return (
    <>
      <Button onClick={handleShare} className={className}>
        <Share2 className="w-4 h-4" />
        {children}
      </Button>
      {drawerMode && (
        <Drawer open={showDrawer} onOpenChange={setShowDrawer}>
          <div className="flex flex-col gap-2">
            <h2 className="text-lg font-bold">{title}</h2>
            <p className="text-lg text-gray-500">{data.url ?? data.text}</p>
          </div>
        </Drawer>
      )}
    </>
  );
};
